/** Route the sidebar links to and the page registers under. */
export const SOCIAL_ANALYTICS_PATH = 'social-analytics'
export const SOCIAL_ANALYTICS_ROUTE = `/${SOCIAL_ANALYTICS_PATH}`

/**
 * The window the metrics sync reschedules each account with (`SYNC_RESCHEDULE_MIN_MS` /
 * `SYNC_RESCHEDULE_MAX_MS` on the API). Surfaced verbatim so the empty states can tell an operator
 * how long a freshly published post waits before it has any numbers at all.
 */
export const METRICS_SYNC_MIN_HOURS = 4
export const METRICS_SYNC_MAX_HOURS = 8

/**
 * How old the newest capture may get before the dashboard stops reporting a timestamp and starts
 * reporting a problem.
 *
 * Three times the slowest reschedule window ({@link METRICS_SYNC_MAX_HOURS}): far enough past the
 * normal cadence that jitter, a paused account or a single failed run cannot trip it, and short
 * enough that a sync that died overnight is flagged the next morning rather than a week later.
 */
export const METRICS_SYNC_STALE_AFTER_HOURS = 24

/** A series needs two captures before it can show movement rather than a single dot. */
export const MIN_HISTORY_POINTS_FOR_CHART = 2

/** `days` in the URL, so a period is shareable and survives a reload. */
export const PERIOD_SEARCH_PARAM = 'days'

export const CHART_COLOR = '#0541d4'
export const CHART_GRID_COLOR = '#e5e7eb'
export const CHART_AXIS_COLOR = '#9ca3af'
